// fix for subscriptions seeming to get cleared if variation is changed
window.addEventListener('load', () => {
  const $$ = function( selector = '' ) {
		return document.querySelectorAll( selector );
	};

  if ( $$('.appstle_sub_widget').length > 0 && $$('.variations').length > 0 ) {
    $$('.variations label[for]').forEach( lbl => {
      lbl.addEventListener('click', e => {
        if ( $$('.appstle_subscription_radio_wrapper input[type="radio"]:checked').length > 0 ) {
          setTimeout( () => {
            $$('.appstle_subscription_radio_wrapper input[type="radio"]:checked')[0].dispatchEvent( new Event('change') );
          }, 600 );
        }
      });
    });
  }
});